import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,

  client: {
    name: 'jansen',
    supportedLanguages: ['de', 'en', 'fr', 'it', 'es', 'nl'],
    downloadCollectionCategoryIds: [],
  },

  apiData: {
    apiID: 'planonePim',
    apiURL: 'https://backend.docucenter.schueco.com/',
    assetURL: 'https://cdn.docu-center.planone.company/',
  },

  keycloakConfig: {
    url: 'https://login-ext.schueco.com/auth',
    realm: 'schueco',
    clientId: 'schueco-docu',
  },

  basicAuth: 'ZG9jdWNlbnRlcjpkb2N1Y2VudGVy',

  mapp: {
    trackDomain: 'schueco01.webtrekk.net',
    trackId: '329102634735066',
  },

  trustcommander: {
    siteId: '6062',
    fileNames: {
      de: 'privacy_v2_53.js',
      en: 'privacy_v2_55.js',
    },
  },

  redirect: {
    targetHost: 'docucenter.jansen.com',
  },

  unleash: {
    url: 'https://unleash-proxy.jansen.docucenter.schueco.dev/proxy',
    clientKey: '600pCFDQxpht8dDE',
    appName: 'default',
    environment: 'jansen-production',
  },
};
